import React, { useState } from 'react';
import { toast } from 'sonner';

const initialState = {
  first_name: '',
  last_name: '',
  email: '',
  company: '',
  phone: '',
  project_details: '',
  consent: false
};

export default function Contact() {
  const [form, setForm] = useState(initialState);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const validate = () => {
    const e = {};
    if (!form.first_name.trim()) e.first_name = 'Påkrevd';
    if (!form.last_name.trim()) e.last_name = 'Påkrevd';
    if (!form.email.trim()) e.email = 'Påkrevd';
    else if (!/\S+@\S+\.\S+/.test(form.email)) e.email = 'Ugyldig e-post';
    if (!form.company.trim()) e.company = 'Påkrevd';
    if (!form.project_details.trim()) e.project_details = 'Påkrevd';
    else if (form.project_details.trim().length < 10) e.project_details = 'Vennligst gi mer detaljer (min 10 tegn)';
    if (!form.consent) e.consent = 'Påkrevd';
    return e;
  };

  const handleSubmit = async (ev) => {
    ev.preventDefault();
    const e = validate();
    if (Object.keys(e).length > 0) { setErrors(e); return; }
    setErrors({});
    setLoading(true);

    // try {
    //   const res = await fetch(`${process.env.REACT_APP_BACKEND_URL || ''}/api/contact`, {
    //     method: 'POST',
    //     headers: { 'Content-Type': 'application/json' },
    //     body: JSON.stringify(form)
    //   });
    //   if (!res.ok) throw new Error();
    //   setSuccess(true);
    //   toast.success('Melding sendt!');
    // } catch {
    //   toast.error('Feil ved sending av melding. Vennligst prøv igjen.');
    // } finally {
    //   setLoading(false);
    // }
    try {
    const res = await fetch(`${process.env.REACT_APP_BACKEND_URL || ''}/api/contact`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(form)
    });
    
    // Read response body first, then parse
    const text = await res.text();
    let data;
    try {
      data = JSON.parse(text);
    } catch (parseError) {
      console.error('Failed to parse response:', text);
      throw new Error('Serverfeil. Prøv igjen senere.');
    }
    
    if (!res.ok) {
      throw new Error(data.detail || 'Noe gikk galt');
    }
    
    setSuccess(true);
    toast.success('Melding sendt!');
  } catch (error) {
    toast.error(error.message || 'Feil ved sending av melding. Vennligst prøv igjen.');
  } finally {
    setLoading(false);
  }
  };

  const handleChange = (ev) => {
    const { name, value, type, checked } = ev.target;
    setForm(p => ({ ...p, [name]: type === 'checkbox' ? checked : value }));
    if (errors[name]) setErrors(p => ({ ...p, [name]: '' }));
  };

  return (
    <div className="win95-form-dialog">
      {success ? (
        <div className="win95-success-dialog">
          <div className="win95-success-icon">✓</div>
          <div className="win95-success-title">Melding Sendt!</div>
          <p>Takk for din henvendelse.</p>
          <p>Vi svarer innen 24 timer.</p>
          <hr className="win95-hr" />
          <button className="win95-btn-ok" onClick={() => setSuccess(false)}>OK</button>
        </div>
      ) : (
        <>
          {/* Form Header */}
          <div className="win95-form-header">
            <div className="win95-form-icon">✉</div>
            <div className="win95-form-title">
              <strong>Ny Melding</strong>
              <span>Fortell oss hva du bygger. Ingen pitch deck nødvendig.</span>
            </div>
          </div>

          <hr className="win95-hr" />

          {/* Form Fields */}
          <form className="win95-form" onSubmit={handleSubmit}>
            <div className="win95-form-row">
              <div className="win95-form-group">
                <label className="win95-label">Fornavn:</label>
                <input 
                  name="first_name" 
                  className={`win95-input ${errors.first_name ? 'error' : ''}`}
                  value={form.first_name} 
                  onChange={handleChange} 
                  data-testid="contact-first-name-input" 
                />
                {errors.first_name && <span className="win95-error">{errors.first_name}</span>}
              </div>
              <div className="win95-form-group">
                <label className="win95-label">Etternavn:</label>
                <input 
                  name="last_name" 
                  className={`win95-input ${errors.last_name ? 'error' : ''}`}
                  value={form.last_name} 
                  onChange={handleChange} 
                  data-testid="contact-last-name-input" 
                />
                {errors.last_name && <span className="win95-error">{errors.last_name}</span>}
              </div>
            </div>

            <div className="win95-form-row">
              <div className="win95-form-group">
                <label className="win95-label">E-post:</label>
                <input 
                  name="email" 
                  type="email" 
                  className={`win95-input ${errors.email ? 'error' : ''}`}
                  value={form.email} 
                  onChange={handleChange} 
                  data-testid="contact-email-input" 
                />
                {errors.email && <span className="win95-error">{errors.email}</span>}
              </div>
              <div className="win95-form-group">
                <label className="win95-label">Selskap:</label>
                <input 
                  name="company" 
                  className={`win95-input ${errors.company ? 'error' : ''}`}
                  value={form.company} 
                  onChange={handleChange} 
                  data-testid="contact-company-input" 
                />
                {errors.company && <span className="win95-error">{errors.company}</span>}
              </div>
            </div>

            <div className="win95-form-group full">
              <label className="win95-label">Hva bygger du?</label>
              <textarea 
                name="project_details" 
                className={`win95-textarea ${errors.project_details ? 'error' : ''}`}
                rows={4}
                value={form.project_details} 
                onChange={handleChange} 
                data-testid="contact-project-details-textarea" 
              />
              {errors.project_details && <span className="win95-error">{errors.project_details}</span>}
            </div>

            <div className="win95-form-group full">
              <label className="win95-checkbox-label">
                <input 
                  type="checkbox" 
                  name="consent" 
                  className="win95-checkbox" 
                  checked={form.consent} 
                  onChange={handleChange} 
                  data-testid="contact-consent-checkbox" 
                />
                <span className="win95-checkbox-text">
                  Jeg samtykker til å bli kontaktet angående min henvendelse
                </span>
              </label>
              {errors.consent && <span className="win95-error">{errors.consent}</span>}
            </div>

            <hr className="win95-hr" />

            <div className="win95-form-buttons">
              <button 
                type="submit" 
                className="win95-btn-send"
                disabled={loading} 
                data-testid="contact-submit-button"
              >
                {loading ? 'Sender...' : 'Send'}
              </button>
              <button type="button" className="win95-btn-cancel" onClick={() => setForm(initialState)}>
                Tøm
              </button>
            </div>
          </form>
        </>
      )}
    </div>
  );
}
